const HUBSPOT_DEAL_URL = /\/(?:deal|record\/0-3)\/(\d+)/

export const hubSpotDealIdFromUrl = (
  url: string | undefined
): string | undefined => url?.match(HUBSPOT_DEAL_URL)?.[1]
